import { render } from "./TeamSubNavigation.vue?vue&type=template&id=58fbe248"
import script from "./TeamSubNavigation.vue?vue&type=script&lang=js"
export * from "./TeamSubNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__